import PaymentMethodAdvancedForm from './PaymentMethodAdvancedForm'

export default PaymentMethodAdvancedForm
